import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/permissionGroupSlice";
import { Link } from "react-router-dom";
import { PermissionSelector } from "slices/permissionGroupSlice";
import { fetchPermissionGroupList } from "slices/permissionGroupSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { removeMultiplePermissionGroup } from "slices/permissionGroupSlice";
const apiService = new Api();

function PermissionGroups() {
    const dispatch = useDispatch()
    const { permissionList, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(PermissionSelector);
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}
    });
    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'name',
        sortDirection: 'desc',
    });


    const handlePageChange = React.useCallback((page) => {
        setCurrentPage(page);
        dispatch(fetchPermissionGroupList(page));
    }, [])
    React.useEffect(() => {
        dispatch(fetchPermissionGroupList())
    }, [])

    const handleAddFacilityPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };

    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }
    const submitCallback = (status, message) => {
        if (status) {

            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            dispatch(fetchPermissionGroupList())
            hideConfirmDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };

    const handleRemoveItems = React.useCallback(() => {
        dispatch(removeMultiplePermissionGroup({ ids: selectedItems }, submitCallback))
    }, [selectedItems])

    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(permissionList.map((val) => val.id.toString()))
    }



    const renderTableHeader = React.useCallback(() => {

        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchPermissionGroupList(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
        }
        return (
            <tr>
                <th className="col-2">
                    <div className="row_check">
                        <span>#</span>
                        <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
                    </div>
                </th>
                <th className="col-4">
                    <TableHeaderItem
                        title="Group Name"
                        sortBy="name"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th className="col-4">
                    <TableHeaderItem
                        title="Created By"
                        sortBy="created_by"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th className="col-1">Status</th>
                <th className="col-1">Actions</th>
            </tr>
        )
    }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, permissionList])


    const renderTableContent = React.useCallback(() => {
        return (
            permissionList?.map((item, index) => {
                return <GroupItem data={item} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddFacilityPopUp} current_page={current_page} pageLength={pageLength} />
            })
        )
    }, [permissionList, selectedItems]);

    const handleClose = React.useCallback(() => {
        refAddutton.current.click();
        setAddForm({ show: false })
    }, [])


    const showConfirmDialog = () => {
        setDeleteModal(true);
        return
    };
    return (
        <ListLayout
            title="Permission Groups"
            time={true}
            buttonTitle="Add Groups"
            renderTableHeader={renderTableHeader}
            renderTableContent={renderTableContent}
            totalPages={totalPages}
            fetchList={fetchPermissionGroupList}
            selectedItems={selectedItems}
            handleRemoveItems={handleRemoveItems}
            renderAddLink={(callback) => <Link to="/permissions/groups/create" className="main_button ml-4">Add Groups</Link>}
            addformModal={false}
            refAddutton={refAddutton}
            addForm={addForm}
            showConfirmDialog={showConfirmDialog}
            handleAddPopUp={handleAddFacilityPopUp}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            sortConfig={sortConfig}
            loader={loader}
            searchPlaceholder="Search groups ..."
            // noOfItems={total}
            noOfItems={0}
            disableBootstrap={true}
        >
            {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
        </ListLayout>
    )

}

const GroupItem = ({
    data, index, selectedItems, handleChange, current_page, pageLength
}) => {
    const dispatch = useDispatch();
    const [status, setStatus] = useState(data?.status);

    const handleStatusChange = (id, s) => {
        setStatus(s ? 1 : 0)
        dispatch(changeStatus(id, { status: s ? 1 : 0 }));

    }
    React.useEffect(() => {
        setStatus(data?.status || 0)

    }, [data])
    const getBackgroundStyle = (status) => {
        return status === 0 ? { background: '#f4f4f4' } : {};
    };
    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);
    return (
        <tr>
            <td style={getBackgroundStyle(status)}>
                <div className="row_check">
                    <span>{serial}</span>
                    <label className="custom-checkbox checkbox">
                        <input type="checkbox" name="select-all" data-value={data.id} checked={selectedItems.includes(data.id.toString())} onChange={handleChange} />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </td>
            <td style={getBackgroundStyle(status)}>
                {data.name}
            </td>
            <td style={getBackgroundStyle(status)}>
                {data.created_by?.name}
            </td>
            <td style={getBackgroundStyle(status)}>
                <CustomSwitch handleChange={(status) => handleStatusChange(data?.id, status)} checked={status == 1 ? true : false} />
            </td>
            <td style={getBackgroundStyle(status)}>
                <div className="row_check">
                    <Link to={`/permissions/groups/update/${data?.id}`} className="table_edit">
                        <img src="/images/edit-button.png" alt="" />
                        Edit
                    </Link>
                </div>
            </td>
        </tr>
    )
}

export default PermissionGroups